const selectPlayerComplaints = (state) => state.playerComplaints;
export const selectPlayerComplaintsData = (state) => selectPlayerComplaints(state).data;
export const selectPlayerComplaintsTotal = (state) => selectPlayerComplaints(state).total;
